// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhs_j bhs_i bhs_bc bhs_r bhs_st","QualityCheckboxes__quality":"ex_b"};